import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches a single member by ID, including their pets. */
export function useGetMember(memberId: string, opts?: { enabled?: boolean }) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['member', memberId],
    staleTime: 60_000,
    enabled: opts?.enabled ?? true,
    queryFn: async () => {
      const response = await api.get('/members/:memberId', { params: { memberId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
  })
}
